<template>
  <v-dialog :value="dialog" max-width="500" @input="$emit('update:dialog', $event)">
    <v-card>
      <v-card-title :class="`headline ${color} lighten-2`">
        <v-icon v-if="icon" left :color="`${color} darken-2`">{{ icon }}</v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-4">
        <div v-html="message"></div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="onCancel">{{ cancelText }}</v-btn>
        <v-btn :color="color" @click="onConfirm">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Xác nhận"
    },
    message: {
      type: String,
      default: "Bạn có chắc chắn muốn thực hiện thao tác này?"
    },
    confirmText: {
      type: String,
      default: "Xác nhận"
    },
    cancelText: {
      type: String,
      default: "Hủy"
    },
    icon: {
      type: String,
      default: "fa-exclamation-triangle"
    },
    color: {
      type: String,
      default: "warning"
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.$emit('update:dialog', false);
    },
    onCancel() {
      this.$emit('cancel');
      this.$emit('update:dialog', false);
    }
  }
};
</script>
